<template>
  <div class="electron-technology">
    <s-r-m-header ref="header" />
    <IndustryDesc ref="industryDesc" :industryInfo="industryInfo" show-menu />
    <ProjectDesc
      :descInfo="{
        title: '电子高科技行业特征',
        description: '璞华易研PLM提供适用于电子科技行业的研发管理解决方案',
        redContent: '电子高科技行业',
        content: '的研发业务具有创新性、跨学科性、高投入性、高风险性、紧密的产业合作以及法规与政策影响等特征。这些特征使得企业在研发过程中需要综合考虑多种因素，以实现技术创新和可持续发展。璞华易研PLM提供的数据管理和协作平台，从创新、需求、产品、文档、变更、测试、缺陷、质量、工艺、成本、合规等环节，为电子高科技行业提供了全方位的解决方案，有助于企业在激烈的市场竞争中保持领先地位。'
      }"
    ></ProjectDesc>
    <ProblemSolving></ProblemSolving>
    <app-benefits ref="appBenefits" />
    <!-- <product-features
      title="产品功能"
      description="PLM产品生命周期管理产品数据管理、项目协同管理、研发管理、设计工具集成"
      :tabList="tabList"
    ></product-features> -->
    <CompanyInfo
      :projectInfo="projectInfo"
    ></CompanyInfo>
    <ResultsOperation
      :descInfo="{
        title: '运营效果',
        descArr1: [
          '建立单一数据源提升数据重用率，降低物料种类和直接物料成本。',
          '流程贯穿整个业务系统，消除系统间信息传递的盲点，打通部门墙。',
          '实现公司数据的标准化管理，包括分类、编码、属性等从而减少数据混乱。',
          '研发资料统一管理，保证智力资产的安全。',
          '签核流程电子化，变更单无需每天来往送批。'
        ],
        descArr2: [
          '送审资料快速收集。',
          'PLM数据发行自动传送到ERP，研发数据准确及时给生产和采购。',
          '在系统中完成项目工作分解，任务分派自动通知各工程师。即时评审交付件。',
          '实现设计软件MCAD/Pads集成，加速设计效率，保证数据源一致性。',
        ]
      }"
    ></ResultsOperation>
    <ChooseUs :nameVals="['electron']"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box /> 
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import IndustryDesc from "@/components/IndustryDesc"
import ProblemSolving from "@/components/ProblemSolving"
import ProjectDesc from "@/components/ProjectDesc"
import AppBenefits from "@/components/AppBenefits"
import ProductFeatures from "@/components/ProductFeatures"
import CompanyInfo from "@/components/CompanyInfo"
import ResultsOperation from "@/components/ResultsOperation"
import ChooseUs from "@/components/ChooseUs"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import { baiduConsult } from "./common.js";

import hy1 from '@/assets/images/hy1.png'

export default {
  components: {
    SRMHeader,
    IndustryDesc,
    ProjectDesc,
    AppBenefits,
    ProductFeatures,
    CompanyInfo,
    ResultsOperation,
    ChooseUs,
    CustomForm,
    FooterBox,
    ProblemSolving
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      industryInfo: {
        bg: hy1,
        // text1: '管理电子高科技公司的',
        text2: '璞华易研PLM为电子高科技企业提供全方位的解决方案',
        // text3: '璞华易研PLM提供完整的全过程的追踪。'
      },
      projectInfo: {
        companyName: '某大型电子高科技公司',
        description: '帮助客户建立起集团级产品数据管理平台，建立文件存储管理机制，提升跨部门协同能力',
        paragraph: [
          '随着科技发展的日新月异，高科技产品不断涌现，并且成为市场的主流，如何不断研发出更多具有科技创造的产品，并且更大的节约成本，提高企业效率，成为当下科技研发型企业所要考虑的问题。',
          '现下越来越多的企业认识到PLM（Product Lifecycle Management，产品生命周期管理）对提高企业竞争优势的重要性，PLM具备提高企业的运营流程与效率，提升企业的核心竞争能力，并保持核心竞争优势持久性的能力。'
        ],
        caseList: [
          {
            num: '01',
            title: '产品数据规范化管理',
            contentList: [
              '建立一套集中的产品数据管理平台；',
              '产品版本信息清晰，产品数据和相关文件紧密关联，数据搜索快速准确；',
              '物料属性、版本以及变更历史记录易追溯；',
              '规范的编码与属性应用，形成设计经验的最大共享与传承；',
              '产品BOM变更历史清晰；'
            ]
          },
          {
            num: '02',
            title: '产品研发文档管理',
            contentList: [
              '打造一套集中管理的文件管理系统；',
              '文档版本清晰、权限按照业务流程灵活设置；',
              '文件进行分类管理，检索方便快速；',
              '实现文档发布及变更流程电子化集中管理；'
            ]
          },
          {
            num: '03',
            title: '产品流程管理',
            contentList: [
              '形成一套完善的产品管理体系；',
              '对产品、图文档的发布审核及设计变更有规范标准的流程支撑；',
              '对研发项目的立项、变更以及终止与结束有比较规范的流程支撑；',
              '对通过平台中业务流程加速部门之间的协同开发作业；',
              '通过产品研发平台建设完善的产品研发管理体系;'
            ]
          },
          {
            num: '04',
            title: '研发项目规范化管理',
            contentList: [
              '形成一套规范的标准的项目管理过程；',
              '项目过程监控清晰；',
              '项目交付物与项目任务紧密关联，交付物驱动任务关闭；',
              '项目中资源利用率清晰，随时了解项目资源的利用状况；',
              '项目成本清晰与可追溯；',
              '项目从立项、计划创建、执行以及结束闭环的项目管理；'
            ]
          }
        ]
      },
      tabList: [
        {
          name: 'first',
          label: '数据管理',
          title: '以数据为核心',
          otherTitle: '将数据管理贯穿产品的全生命周期',
          effectDrawing: require('@/assets/images/gn1.png'),
          contentList: [
            {
              title: '物料管理',
              content: '物料编码规则、物料属性定义、物料的生命周期管理、物料分类定义'
            },
            {
              title: 'bom管理',
              content: 'bom结构、替代料管理、bom正反结构查询'
            },
            {
              title: '制造商管理',
              content: '制造商管理、制造商部件号管理'
            },
            {
              title: '文档管理',
              content: '文档分类、文档版本、文档权限等管理'
            }
          ]
        },
        {
          name: 'second',
          label: '变更管理',
          title: '根据用户的个性化需求，支持用户定义各种规则，对变更进行',
          otherTitle: '跟踪和管理',
          effectDrawing: require('@/assets/images/gn2.png'),
          contentList: [
            {
              content: '内置了行业标准的ECR-ECO的工程变更解决方案'
            },
            {
              content: '可以根据客户的个性化需求进行业务流程配置'
            },
            {
              content: '提供了行业领先的用户可编程引擎，支持用户定义各种规则'
            }
          ]
        },
        {
          name: 'third',
          label: '项目管理',
          title: '项目计划＆项目进度＆项目交付＆项目报表',
          effectDrawing: require('@/assets/images/gn3.png'),
          contentList: [
            {
              content: '采用最新的BS技术实现项目中的各种管理功能'
            },
            {
              content: '包含项目计划、交付、资源、工时、费用、报表等核心功能'
            },
            {
              content: '帮助企业实现项目集的管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'four',
          label: '数据建模',
          title: '通过数据建模，支持客户的个性化需求',
          effectDrawing: require('@/assets/images/gn4.png'),
          contentList: [
            {
              content: '提供强大的配置平台，支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限'
            },
            {
              content: '实现完全可配置的业务，支持数据、流程、字段级别的数据建模和精细化的权限控制'
            }
          ]
        },
        {
          name: 'five',
          label: '在线可视化',
          title: '目前支持超过40多种主流的文件格式在线预览，所见即所得',
          effectDrawing: require('@/assets/images/gn5.png'),
          contentList: [
            {
              content: '采用最新的BS架构实现了文件的预览，不需要用户客户端安装任何的客户端软件'
            },
            {
              content: '支持主流2D文件(Office、CAD、压缩文件、文本文件、图片、音频)格式的预览'
            },
            {
              content: '支持主流3D文件(prt、asm、pcb、stp) 格式的预览'
            }
          ]
        },
        {
          name: 'six',
          label: '第三方接入',
          title: '轻松实现与第三方软件的对接',
          effectDrawing: require('@/assets/images/gn6.png'),
          contentList: [
            {
              content: '通过标准的API接口和Webservice接口，实现PLM的数据同企业的其他业务系统和移动办公系统的深度集成'
            },
            {
              content: '自带主流的ERP集成接口和移动端集成，支持数据导出'
            }
          ]

        }
      ]
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.electron-technology {
  ::v-deep .project-desc {
    .project-content {
      width: 140rem;
    }
  }
  ::v-deep .industry-desc {
    .text2 {
      font-size: 5rem !important;
      margin-top: 4rem;
    }
  }
  ::v-deep .systemFunction-container {
    background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  }
  ::v-deep .point-of-pain {
    .point-of-pain-title {
      padding: 10rem 0 2.4rem !important;
    }
    .point-of-pain-description {
      padding-bottom: 6.2rem !important;
    }
    .list-item {
      padding: 5.6rem 5.2rem 0rem 4.8rem !important;
      height: 24.6rem !important;
      .cl-list {
        margin-top: 3rem !important;
      }
      .cl-l-i-content {
        padding-left: 0 !important;
        &::before {
          border: none !important;
        }
      }
    }
  }
  .typical-user {
    ::v-deep .systemFunction-list {
      height: 55.2rem;
    }
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
